import React from 'react';
import { observer } from 'mobx-react';

import { modalStore } from 'apps/modals/app';
import { Paragraph } from 'components';
import {
  StepsColumnWrapper,
  ActionsHeader,
  FileRow,
  ContributionStep,
  IconStyled,
} from 'apps/project/tabs/conflicts/styles';

export const StepColumn = observer(({ conflicts, activeConflict, manager }) => {
  if (!conflicts) return null;
  const conflictRows = [];
  conflicts.forEach((conflict, index) => {
    const fileName = conflict.path.split('/').slice(-1)[0];
    const isActive = conflicts.apps[activeConflict].path === conflict.path;
    conflictRows.push(
      <FileRow
        key={conflict.id}
        active={isActive}
        onClick={() => manager.SetActiveConflict(index)}
      >
        {conflict.markedResolved && <IconStyled name='success' />}
        <Paragraph>{fileName}</Paragraph>
        <Paragraph>{conflict.path}</Paragraph>
      </FileRow>,
    );
  });

  return (
    <StepsColumnWrapper>
      <ActionsHeader active first>
        <Paragraph>
          1. Resolve conflicts <span>({conflicts.length})</span>
        </Paragraph>
      </ActionsHeader>
      {conflictRows}
      <ContributionStep
        active={manager.allConflictsResolved}
        onClick={manager.Finalise}
        blink={manager.allConflictsResolved && modalStore.component === ''}
      >
        <Paragraph>2. Finalise Contribution</Paragraph>
      </ContributionStep>
    </StepsColumnWrapper>
  );
});
